const companies = state => state.companies
const isLoading = state => state.isLoading
const hasError = state => state.error !== null
const error = state => state.error
const hasCompanies = state => state.companies.length > 0
const company = state => state.company
const hasCompany = state => state.company !== null
const formIsSubmitted = state => state.formIsSubmitted
const getForm = state => state.form

export default {
  companies, isLoading, hasError, error, hasCompanies, company, hasCompany, formIsSubmitted, getForm,
}
